import { APP_ROUTES } from '@routes/routes.constants';

import { InstructLandingParams } from './InstructRedirectPage.types';

/**
 * Resolves the Instruct module landing route based on permissions and feature flags.
 *
 * Priority order:
 * 1. My Schedule (flag + permission)
 * 2. Availability Manager (flag + permission)
 * 3. Resource Lookup (flag + permission)
 * 4. Customer Training Documents (permission only)
 * 5. CAE Documents (permission only)
 * 6. null — no valid landing page (forbidden)
 */
export function resolveInstructLandingRoute(
  params: InstructLandingParams
): string | null {
  const { hasPermission, flags } = params;

  if (
    Boolean(flags['instructormyschedule']) &&
    hasPermission('InstructorSchedule_View_Own')
  ) {
    return APP_ROUTES.INSTRUCT_MY_SCHEDULE;
  }

  if (
    Boolean(flags['instructorExpAvailabilityManager']) &&
    hasPermission('AvailabilityManager_FullAccess_Own')
  ) {
    return APP_ROUTES.INSTRUCT_AVAILABILITY_MANAGER;
  }

  if (
    Boolean(flags['instructorExpResourceLookup']) &&
    hasPermission('Resources_View_MyLocations')
  ) {
    return APP_ROUTES.RESOURCE_LOOKUP;
  }

  if (hasPermission('CustomerTrainingDocuments_View_All')) {
    return APP_ROUTES.INSTRUCT_DOCUMENTS_COMPANIES;
  }

  if (hasPermission('CAETrainingDocuments_View_All')) {
    return APP_ROUTES.INSTRUCT_DOCUMENTS_CAE;
  }

  return null;
}
